export const en = {
  typeaheads: {
    adminNonprofit: 'Nonprofit',
    adminOpportunity: 'Opportunity',
    adminCompany: 'Company',
    adminRsvpNonprofit: 'ex. Quest Food Exchange',
    adminSlackChannelSubscription: 'Slack Channel',
    purposelyAdminOpportunityRequest: 'Opportunity Request',
    departments: 'Department',
    causes: 'Cause',
    rsvpEventRegions: 'Location',
    companyAdminEmployeeCountries: 'Country',
    companyAdminEmployeeRegions: 'Region',
    companyAdminSlackChannels: 'Slack Channel',
    companyAdminEmployees: 'Type the name of the volunteer you want to add',
    adminNonprofit: 'Nonprofit',
    adminOpportunity: 'Opportunity',
    adminCompany: 'Company',
    adminRsvpNonprofit: 'Nonprofit',
  },
}
